import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ThemeState {
  mode: 'light' | 'dark' | 'system';
  primaryColor: string;
  layout: {
    type: 'default' | 'compact' | 'spacious';
    sidebarCollapsed: boolean;
  };
  accessibility: {
    highContrast: boolean;
    reducedMotion: boolean;
    fontSize: 'small' | 'medium' | 'large';
  };
}

const initialState: ThemeState = {
  mode: 'system',
  primaryColor: '#3b82f6', // blue-500
  layout: {
    type: 'default',
    sidebarCollapsed: false,
  },
  accessibility: {
    highContrast: false,
    reducedMotion: false,
    fontSize: 'medium',
  },
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeMode: (state, action: PayloadAction<'light' | 'dark' | 'system'>) => {
      state.mode = action.payload;
    },
    setPrimaryColor: (state, action: PayloadAction<string>) => {
      state.primaryColor = action.payload;
    },
    setLayoutType: (state, action: PayloadAction<'default' | 'compact' | 'spacious'>) => {
      state.layout.type = action.payload;
    },
    toggleSidebar: (state) => {
      state.layout.sidebarCollapsed = !state.layout.sidebarCollapsed;
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.layout.sidebarCollapsed = action.payload;
    },
    updateAccessibility: (state, action: PayloadAction<Partial<ThemeState['accessibility']>>) => {
      state.accessibility = { ...state.accessibility, ...action.payload };
    },
    resetTheme: (state) => {
      return { ...initialState, mode: state.mode }; // Keep current mode
    },
  },
});

export const {
  setThemeMode,
  setPrimaryColor,
  setLayoutType,
  toggleSidebar,
  setSidebarCollapsed,
  updateAccessibility,
  resetTheme,
} = themeSlice.actions;

export default themeSlice.reducer;
